import { NAPageItemConfigType } from './ConfigTypes';
import AppealsNoticePageItemConfig from './configs/AppealsNoticePageItemConfig';
import AppealsProcessPageItemConfig from './configs/AppealsProcessPageItemConfig';
import BadUtterancesPageItemConfig from './configs/BadUtterancesPageItemConfig';
import BanDescriptionPageItemConfig from './configs/BanDescriptionPageItemConfig';
import ChargebackInfoNoticePageItemConfig from './configs/ChargebackInfoNoticePageItemConfig';
import ChargebackReactivateNoticePageItemConfig from './configs/ChargebackReactivateNoticePageItemConfig';
import CommunityStandardsPageItemConfig from './configs/CommunityStandardsPageItemConfig';
import ConsequenceTransparencyPageItemConfig from './configs/ConsequenceTransparencyPageItemConfig';
import DeleteDescriptionPageItemConfig from './configs/DeleteDescriptionPageItemConfig';
import ForeshadowPageItemConfig from './configs/ForeshadowPageItemConfig';
import ModeratorNotePageItemConfig from './configs/ModeratorNotePageItemConfig';
import ReactivateNoticePageItemConfig from './configs/ReactivateNoticePageItemConfig';
import StartDatePageItemConfig from './configs/StartDatePageItemConfig';
import TermsOfUsePageItemConfig from './configs/TermsOfUsePageItemConfig';
import ViolationPageItemConfig from './configs/ViolationPageItemConfig';

// Note: This ordering matters, since we want to display these items in a specific order.
const NAPageItemConfigList: Array<NAPageItemConfigType> = [
  ForeshadowPageItemConfig,
  TermsOfUsePageItemConfig,
  StartDatePageItemConfig,
  ModeratorNotePageItemConfig,
  ConsequenceTransparencyPageItemConfig,
  BadUtterancesPageItemConfig,
  ViolationPageItemConfig,
  ChargebackInfoNoticePageItemConfig,
  CommunityStandardsPageItemConfig,
  BanDescriptionPageItemConfig,
  DeleteDescriptionPageItemConfig,
  AppealsProcessPageItemConfig,
  AppealsNoticePageItemConfig,
  ReactivateNoticePageItemConfig,
  ChargebackReactivateNoticePageItemConfig
];

export default NAPageItemConfigList;
